<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center text-muted mb-4">
            <i class="fa fa-user fa-fw fa-2x"></i>
            <br />Ingrese sus credenciales
          </div>
          <form role="form">
            <base-input
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Número de documento / CUIT / Usuario"
              addon-left-icon="ni ni-email-83"
              v-model="model.name"
              @keyup.enter.native="login"
            ></base-input>

            <base-input
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="model.password"
              @keyup.enter.native="login"
            ></base-input>
            <label class="label-link" @click="olvidePassword">
              <small>{{buttonResend.buttonText}}</small>
            </label>

            <!-- <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
            </base-checkbox>-->
            <div v-if="Captcha.ShowCaptcha">
              <div class="col-md-12" style="display:flex;">
                <div class="text-center text-muted col-md-12">Ingresá el captcha</div>
                <div :style="CaptchaRectangleStyle"></div>
              </div>
              <img :src="Captcha.CaptchaImage" style="width:70%" />
              <base-button
                type="success"
                size="sm"
                style="margin-left: 44px;"
                @click="cargarImagen"
              >
                <i class="fa fa-fw fa-redo"></i>
              </base-button>
              <div class="row form-group" style="margin-top:15px">
                <div class="col-md-12">
                  <base-input
                    placeholder="Código de seguridad"
                    class="input-group-alternative mb-3"
                    v-model="model.captcha"
                  ></base-input>
                </div>
              </div>
            </div>
            <div class="text-center col-md-12">
              <base-button type="primary" @click="login" class="my-4">Ingresar</base-button>
            </div>
            <div class="text-center col-md-12">
              <router-link to="/registro">Registrate</router-link>
            </div>

            <div class="container" style="text-align: center; margin-top:20px;">
                <a :href="model.urlTawkTo" target="_blank" style="cursor: pointer !important;">
                    <img src="/img/logorojoChat.png" class="img-fluid" style="width:15%;" />
                </a>
            </div>
            <div class="text-center col-md-12" style="cursor: pointer !important;">
                <a :href="model.urlTawkTo" target="_blank">
                    Chat Online
                </a>
            </div>
          </form>
        </div>
      </div>
      <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
      </div>-->
    </div>
    <contact-help-desk ref="contact-help-desk" titleModal="Error de login" />
  </div>
</template>

<style>
.label-link {
  cursor: pointer;
}
</style>
<script>
import axios from 'axios';
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import firebase from "firebase";
import ContactHelpDesk from "@/views/ContactHelpDesk";

export default {
  components: {
    "contact-help-desk": ContactHelpDesk
  },
  name: "login",
  data() {
    return {
      model: {
        name: "",
        password: "",
        deviceID: "",
        version: "",
        so: 3,
        remember: false,
        captcha: "",
        ipLogin: "",
        deviceModel: "",
        deviceModelID: "",
        urlTawkTo: "",
      },
      buttonResend: {
        buttonText: "Olvide mi contraseña",
        buttonDisabled: true
      },
      countDown: 0,
      Captcha: {
        CaptchaID: 0,
        CaptchaImage: "",
        ShowCaptcha: false
      },
      CaptchaRectangleStyle: {
        backgroundcolor: "",
        height: "28px",
        width: "33px",
        marginLeft: "10px",
        borderradius: "6px;"
      }
    };
  },
  methods: {
    GetUrlTawkTo(){
      let context = this;

      axiosHelpers.axiosGet("Account/GetUrlTawkTo", {}, context, function(data){
        context.model.urlTawkTo = data.ResponseVM.Url;
      });
    },
    olvidePassword() {
      if (this.countDown != 0) {
        return;
      }
      let context = this;
      if (this.model.name == "") {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Complete Número de documento / Nombre de usuario / CUIT",
          context
        );
        return;
      }

      axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/CrearSolicitudCambioPassword",
        {
          Identifier: this.model.name,
          AvoidCodeValidation: true
        },
        this,
        function(data) {
          if (data.ResponseVM.Resultado) {
            notificationHelpers.showSuccess(
              "Mail enviado!",
              "Se ha enviado un mail a " +
                data.ResponseVM.EmailDestino +
                " con un enlace para que pueda cambiar su contraseña",
              context
            );
          }
          context.countDown = data.ResponseVM.TimeToResend;
          context.countDownTimer();
        }
      );
    },
    countDownTimer() {
      let context = this;
      if (context.countDown > 0) {
        setTimeout(() => {
          context.countDown -= 1;
          if (context.countDown == 1)
            context.buttonResend.buttonText =
              "Disponible en " + context.countDown.toString() + " segundo";
          else
            context.buttonResend.buttonText =
              "Disponible en " + context.countDown.toString() + " segundos";
          this.countDownTimer();
        }, 1000);
      } else {
        context.buttonResend.buttonText = "Olvide mi contraseña";
        context.buttonResend.buttonDisabled = false;
      }
    },
    cargarImagen() {
      let context = this;
      axiosHelpers.axiosGet("Account/GetReCaptcha", {}, this, function(data) {
        context.Captcha.CaptchaImage =
          "data:image/png;base64," + data.ResponseVM.Image;
        context.Captcha.CaptchaID = data.ResponseVM.EntityID;
      });
    },

    getFingerprint() {
        const userAgent = navigator.userAgent;
        const screenInfo = `${window.screen.width}x${window.screen.height}`;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const deviceMemory = navigator.deviceMemory || 'N/A';
        const cpuCores = navigator.hardwareConcurrency || 'N/A';

        const fingerprintString = `${userAgent}-${screenInfo}-${timezone}-${deviceMemory}-${cpuCores}`;

        this.model.deviceModel = fingerprintString;
        this.model.deviceModelID = btoa(fingerprintString); // Codifica en Base64
    },

    async login() {
      let context = this;
      try {

        try {
          //context.getFingerprint();
          const FingerprintJS = window.FingerprintJS;

          // Inicializa FingerprintJS
          const fp = await FingerprintJS.load();
          // Obtiene la huella digital
          const result = await fp.get();
          const fingerprint = result.visitorId;
 
          // Convertir la cadena a Base64
          this.model.deviceModelID = btoa(fingerprint);
        } catch (error) {
          console.log("Error obtener Fingerprint: " + error);
        }

        try {
          const response = await axios.get('https://ipservice.resimple.com.ar?format=json');
          this.model.ipLogin = response.data.ip;
        } catch (error) {
          console.log("Error obtener IP Resimple: " + error);

          try {
            const response = await axios.get('https://api64.ipify.org?format=json');
            this.model.ipLogin = response.data.ip;
          } catch (error) {
            console.log("Error obtener IP: " + error);
          }
        }
       
        try{
          const messaging = firebase.messaging();
          this.model.deviceID = await messaging.getToken();
        }catch(error){
          console.log("Error firebase: " + error);
        }

        const userAgent = navigator.userAgent;
        this.model.deviceModel = this.model.ipLogin + '_' + userAgent;

      } catch {
      } finally {
        axiosHelpers.axiosPostWithoutAlerts(
          "Login/MakeLogin",
          {
            Name: this.model.name,
            Password: this.model.password,
            DeviceID: this.model.deviceID,
            Version: this.model.version,
            SO: this.model.so,
            Remember: this.model.remember,
            CaptchaCode: this.model.captcha,
            CaptchaID: this.Captcha.CaptchaID,
            IPLogin: this.model.ipLogin,
            DeviceModel: this.model.deviceModel,
            DeviceModelID: this.model.deviceModelID
          },
          this,
          function(data) {
            if (
              data.ResponseVM != null &&
              data.ResponseVM.Token != null &&
              data.ResponseVM.Token != ""
            ) {

              context.$store.dispatch("login", data.ResponseVM).then(() => {

                // // Si el email no fue verificado y no es Cajero o Supervisor
                // else
                // if (
                //   !data.ResponseVM.IsMailVerify &&
                //   !data.ResponseVM.IsCashier &&
                //   !data.ResponseVM.IsSupervisor
                // ) {
                //   context.$router.push("emailvalidationform");
                //   return;
                // }

                // Si la identidad no fue verificada y no es Cajero o Supervisor
                // if (
                //   !data.ResponseVM.IdentityWasVerificated &&
                //   !data.ResponseVM.IsCashier &&
                //   !data.ResponseVM.IsSupervisor
                // ) {
                //   context.$router.push({
                //     name: "verificacionidentidadlogin",
                //     params: { showAcceptButton: true }
                //   });
                //   return;
                // }

                // Si pide cambio de password
                // if (data.ResponseVM.ChangePassword) {
                //   context.$router.push("loginchangepassword");
                // }

                // // Si es un nuevo dispositivo
                // if(data.ResponseVM.NewDevice){
                //   context.$router.push({ 
                //      name: "NuevoInicioSesion"
                //   });
                //   return;
                // }

                  // Si no tiene PIN Configurado y no es Cajero o Supervisor
                  // if (
                  //   !data.ResponseVM.UsePaymentPin &&
                  //   !data.ResponseVM.IsCashier &&
                  //   !data.ResponseVM.IsSupervisor
                  // ) {
                  //   // -- Si uso la verificación en 2 pasos no la ejecutamos
                  //   // if (
                  //   //   context.$store.getters.useTwoStepsTwoStepVerification
                  //   // ) {
                  //     context.$router.push("/InitialPinConfiguration");
                  //   // } else {
                  //   //   context.$router.push({
                  //   //     name: "InitialSelectSecurityMethod",
                  //   //     params: {
                  //   //       accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                  //   //       useRouterPush: true,
                  //   //       dataPost: { name: "InitialPinConfiguration" }
                  //   //     }
                  //   //   });
                  //   //   return;
                  //   // }
                  // }

                                  //-- Indica si tiene que Verificación de 2 pasos activa
                // if (context.$store.getters.ShouldPerformTwoStepVerification) {
                //   // Si no tiene Telefono verificado y no es Cajero o Supervisor
                //   if (
                //     !data.ResponseVM.IsPhoneVerify &&
                //     !data.ResponseVM.IsCashier &&
                //     !data.ResponseVM.IsSupervisor
                //   ) {
                //     context.$router.push("InitialPhoneValidation");
                //     return;
                //   }

                //   // Si no tiene Verificación de dos pasos Configurada y no es Cajero o Supervisor
                //   if (
                //     !data.ResponseVM.TwoStepVerification &&
                //     !data.ResponseVM.IsCashier &&
                //     !data.ResponseVM.IsSupervisor
                //   ) {
                //     context.$router.push("InitialIdentityValidationTwoSteps");
                //     return;
                //   }
                // }

                // -- Si es cajero
                if (data.ResponseVM.IsCashier) {
                  if (data.ResponseVM.IsLoggedCashBox) {
                    context.$router.push("dashboard");
                  } else {
                    context.$router.push("logincajero");
                  }
                } else {
                  context.$router.push("dashboard");
                }
              });
            } else if (data.ResponseVM != null) {
              context.Captcha.CaptchaID = data.ResponseVM.CaptchaID;
              context.Captcha.CaptchaImage =
                "data:image/png;base64," + data.ResponseVM.CaptchaImage;
              context.Captcha.ShowCaptcha = data.ResponseVM.ShowCaptcha;

              if (data.ResponseVM.HelpDeskInformation != null) {
                var helpDeskInformation = data.ResponseVM.HelpDeskInformation;
                helpDeskInformation.Message =
                  data.ResponseVM.HelpDeskErrorMessage;
                //helpDeskInformation.Show = data.ResponseVM.ShowHelpDeskInfo;
                helpDeskInformation.Show = true;
                helpDeskInformation.ShowUnlockMail =
                  data.ResponseVM.BlockedAccount;
                helpDeskInformation.Name = context.model.name;
                helpDeskInformation.ShowContactarSoporte =
                  data.ResponseVM.ShowHelpDeskInfo;
                context.$refs["contact-help-desk"].setHelpDeskInformation(
                  helpDeskInformation
                );
              }
            } else {
              notificationHelpers.showError(
                "Alerta!",
                data.Alerts[0].Message,
                context
              );
            }
          }
        );
      }
    }
  },
  beforeMount: function() {
    this.GetUrlTawkTo();
  }
};
</script>
